<template>

<aside class="column is-3 is-narrow-mobile is-fullheight section is-hidden-mobile">
    <p class="text-center"><img v-bind:src="this.logo" alt="School logo"></p>
    <p class="menu-label is-hidden-touch text-center"></p>
    <ul class="menu-list">
        <li>
            <a v-on:click="goDashboard()" v-bind:class="isActive('Dashboard')">
                <span class="icon"><i class="fa fa-home"></i></span> Dashboard
            </a>
        </li>

        <!-- <li>
            <a v-on:click="goStaffAttendance()" v-bind:class="isActive('StaffAttendanceMain')">
                <font-awesome-icon icon="user-check" class="icon" /> Staff Attendance
            </a>
        </li> -->
        <li>
            <a v-on:click="goClassDashboard()" v-bind:class="isActive('ClassDashboard')">
                <font-awesome-icon icon="user-friends" class="icon" /> Class Dashboard
            </a>
        </li>
        <li>
            <a v-on:click="goGroupDashboard()" v-bind:class="isActive('GroupDashboard')">
                <font-awesome-icon icon="users" class="icon" /> Group Dashboard
            </a>
        </li>
        <li>
            <a v-on:click="goTeachersActivities()" v-bind:class="isActive('TeachersActivities')">
                <font-awesome-icon icon="users" class="icon" /> Teachers' Activities
            </a>
        </li>
        <li>
            <a v-on:click="goLeaderboard()" v-bind:class="isActive('Leaderboard')">
                <span class="icon"><i class="fa fa-trophy"></i></span> Leaderboard
            </a>
        </li>
        <!-- <li>
            <a href="#" class="">
                <span class="icon"><i class="fa fa-info"></i></span> Report
            </a>
        </li> -->
        <li>
            <a href="#">
                <span class="icon"><i class="fa fa-table"></i></span> Database
            </a>
            <ul>
                <li>
                    <a v-on:click="goDbKelas()" v-bind:class="isActive('DbKelasMain')">
                        <span class="icon is-small"><i class="fa fa-link"></i></span> Class
                    </a>
                </li>
                <li>
                    <a v-on:click="goDbGroup()" v-bind:class="isActive('DbGroupMain')">
                        <span class="icon is-small"><i class="fa fa-link"></i></span> Groups
                    </a>
                </li>
                <li>
                    <a v-on:click="goDbStaff()" v-bind:class="isActive('StaffMain')">
                        <span class="icon is-small"><i class="fa fa-link"></i></span> Teachers/Staff
                    </a>
                </li>
                <!-- <li>
                    <a v-on:click="goDbBadges()" v-bind:class="isActive('BadgesHome')">
                        <span class="icon is-small"><i class="fa fa-link"></i></span> Badges
                    </a>
                </li> -->
                <!-- <li>
                    <a v-on:click="goDbStudents()" v-bind:class="isActive('StudentsMain')">
                        <span class="icon is-small"><i class="fa fa-link"></i></span> Students
                    </a>
                </li> -->
                <li>
                    <a v-on:click="goDbPositiveBehaviour()" v-bind:class="isActive('PositiveBehaviourMain')">
                        <span class="icon is-small"><i class="fa fa-link"></i></span> Positive Behaviour
                    </a>
                </li>
                <!-- <li>
                    <a v-on:click="goDbBehaviourCategory()" v-bind:class="isActive('DbBehaviourCategoryMain')">
                        <span class="icon is-small"><i class="fa fa-link"></i></span> Behaviour Category
                    </a>
                </li> -->
                <li>
                    <a v-on:click="goDbForms()" v-bind:class="isActive('Forms')">
                        <span class="icon is-small"><i class="fa fa-link"></i></span> Forms
                    </a>
                </li>
            </ul>
        </li>
        <li>
            <a v-on:click="goNotifications()" v-bind:class="isActive('Notifications')">
                <font-awesome-icon icon="bell" class="icon" /> Notifications
            </a>
        </li>
        <li>
            <a v-on:click="goSettings()" v-bind:class="isActive('Settings')">
                <span class="icon"><i class="fa fa-wrench"></i></span> Settings
            </a>
        </li>
        <li>
            <a v-on:click="logout()">
                <span class="icon"><i class="fa fa-sign-out"></i></span> Logout
            </a>
        </li>
    </ul>
</aside>
</template>

<script>
import "./public/style.scss";

export default {
    name: "SideMenu",
    data() {
        return {
            schoolID: '',
            logo: '',
            currentRouteName: ''
        };
    },
    created() {
        this.currentRouteName = this.$router.currentRoute.name
        this.logo = localStorage.getItem('schoolLogo')
    },
    mounted(){
        this.$root.$on('activeSideMenu', (item, response) => {

            var name = ""
            if ((item === "ClassDashboardSingle") || (item === "ClassPositiveHistory") || (item === "ClassPositiveDetails") || (item === "ClassManageStudents")){
                name = "ClassDashboard"
            }else if (item === "StaffAttendanceDetails"){
                name = "StaffAttendanceMain"
            }

            this.currentRouteName = name
            this.isActive(name)
        });
    },
    methods: {
        isActive(name){
            if (this.currentRouteName == name){
                return 'is-active'
            }else{
                return ''
            }
        },
        goStaffAttendance(){
            this.$router.push({
                name: "StaffAttendanceMain"
            });
        },
        goDashboard() {
            this.$router.push({
                name: "Dashboard"
            });
        },
        goClassDashboard(){
            this.$router.push({
                name: "ClassDashboard"
            });
        },
        goGroupDashboard(){
            this.$router.push({
                name: "GroupDashboard"
            });
        },
        goTeachersActivities(){
            this.$router.push({
                name: "TeachersActivities"
            });
        },
        goLeaderboard(){
            this.$router.push({
                name: "LeaderboardV1"
            });
        },
        goDbKelas() {
            this.$router.push({
                name: "DbKelasMain"
            });
        },
        goDbGroup() {
            this.$router.push({
                name: "DbGroupMain"
            });
        },
        // goDbStudents() {
        //     this.$router.push({
        //         name: "StudentsMain"
        //     });
        // },
        goDbStaff() {
            this.$router.push({
                name: "StaffMain"
            });
        },
        goDbPositiveBehaviour() {
            this.$router.push({
                name: "PositiveBehaviourMain"
            });
        },
        goDbBehaviourCategory() {
            this.$router.push({
                name: "DbBehaviourCategoryMain"
            });
        },
        goDbBadges() {
            this.$router.push({
                name: "BadgesHome"
            });
        },
        goDbForms() {
            this.$router.push({
                name: "DbFormMain"
            });
        },
        goNotifications() {
            this.$router.push({
                name: "NotificationsHome"
            });
        },
        goSettings() {
            this.$router.push({
                name: "Settings"
            });
        },
        logout(){
            localStorage.removeItem('user')
            localStorage.removeItem('jwtToken')
            localStorage.removeItem('email')
            localStorage.removeItem('sessionID')
            localStorage.removeItem('schoolID')
            localStorage.removeItem('input_email')
            localStorage.removeItem('input_pass')
            localStorage.removeItem('autoLoginAfterReload')
            this.$emit("authenticated", false)
            this.$router.push({
                name: "Login"
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/SideMenu.vue